import isEmpty from "lodash/isEmpty";

export const getReformatData = (data) => {
  let initialData = [{ y: 4 }, { y: 3 }, { y: 4 }, { y: 5 }, { y: 4 }, { y: 3 }];

  if (isEmpty(data)) return initialData;

  return data.map((d) => ({ y: d.count })).slice(-6);
};
